import "../styles/legal-footer.css";

export function LegalLinks() {
  return <><a href="/terms">Terms</a><span aria-hidden="true"> · </span><a href="/privacy">Privacy</a></>;
}

export function LegalFooter() {
  return <footer className="legal-footer" aria-label="Legal documents"><LegalLinks/></footer>;
}
